import { useQuery } from '@hooks/reactQuery';

import { getNetworkOperators } from '@api/assetsRent';

import { generateSelectOptions } from '@utils/generateSelectOptions/generateSelectOptions';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { GET_NETWORK_OPERATORS } from '@constants/queryKeys';

interface IUseQueryNetworkOperatorsReturnType {
	isLoadingNetworkOperators: boolean;
	networkOperators: Array<TSelectOption>;
}

export const useQueryNetworkOperators = (isAO: boolean): IUseQueryNetworkOperatorsReturnType => {
	const {
		data: networkOperators,
		isInitialLoading,
	} = useQuery({
		queryKey: [GET_NETWORK_OPERATORS],
		queryFn: getNetworkOperators,
		refetchOnWindowFocus: false,
		enabled: [isAO],
	});

	return {
		networkOperators: generateSelectOptions({ data: networkOperators, value: 'id', label: 'name' }),
		isLoadingNetworkOperators: isInitialLoading,
	};
};
